import React from 'react'
import './index.scss'

interface AddDescriptionFormProps {
    description: string
    descriptionHelpText?: string
    showLabel?: boolean
    setDescription(newUpdatedDescription: string): void
}

const AddDescriptionForm = (props: AddDescriptionFormProps) => {
    const { description, descriptionHelpText, showLabel = true, setDescription } = props
    return (
        <div className="add-description-item">
            {showLabel && <div>Add Note (Optional)</div>}
            <textarea value={description} onChange={(e) => setDescription(e.target.value)} />
            {descriptionHelpText && <i>{descriptionHelpText}</i>}
        </div>
    )
}
export default AddDescriptionForm
